import React, { useState, useEffect } from 'react';
import '../../styles/CustomerSiteStyles/AboutUs.css';
import mac from '../../assets/macpic.jpeg';
import layne from '../../assets/LayneMcIntosh.JPG';
import richard from '../../assets/richardpic.jpeg';
import tony from '../../assets/TonyJudd.JPG';
import matt from '../../assets/mattpic.jpeg';
import grouppic from '../../assets/GroupWorkPic.jpg';
import SethThomas from '../../assets/SethThomas.JPG';
import john from '../../assets/JohnBlumenschien.JPG';
import lacy from '../../assets/LacyPic.jpeg';

const AboutUs = () => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const [countersVisible, setCountersVisible] = useState(false);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    const handleScroll = () => {
      const statsSection = document.getElementById('stats-section');
      if (statsSection) {
        const rect = statsSection.getBoundingClientRect();
        setCountersVisible(rect.top < window.innerHeight && rect.bottom >= 0);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const Counter = ({ end, duration, label, suffix = "" }) => {
    const [count, setCount] = useState(0);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
      if (!countersVisible) return;
      let startTime = null;
      let animationFrameId;

      const step = (timestamp) => {
        if (!startTime) startTime = timestamp;
        const progress = Math.min((timestamp - startTime) / duration, 1);
        setCount(Math.floor(progress * end));
        if (progress < 1) {
          animationFrameId = window.requestAnimationFrame(step);
        }
      };

      animationFrameId = window.requestAnimationFrame(step);
      return () => window.cancelAnimationFrame(animationFrameId);
    }, [end, duration]);

    return (
      <div className="counter-box">
        <div className="counter-number">{count}{suffix}</div>
        <div className="counter-label">{label}</div>
      </div>
    );
  };

  const [currentIndex, setCurrentIndex] = useState(0);
  const [slidesPerView, setSlidesPerView] = useState(3);

  useEffect(() => {
    const updateSlides = () => {
      if (window.innerWidth <= 768) setSlidesPerView(1);
      else if (window.innerWidth <= 1024) setSlidesPerView(2);
      else setSlidesPerView(3);
    };
    updateSlides();
    window.addEventListener('resize', updateSlides);
    return () => window.removeEventListener('resize', updateSlides);
  }, []);

  useEffect(() => {
    setCurrentIndex(0);
  }, [slidesPerView]);

  const teamMembers = [
    {
      name: "Mac McIntosh",
      position: "CEO",
      bio: "Mac manages Affordable Roofing + Solar Solutions and has led the company's growth from a local Louisville operation to a multi-state business serving Kentucky, Oklahoma, Nebraska, Missouri, and Kansas.",
      profilePic: mac,
      contact: "502-714-0997"
    },
    {
      name: "Layne McIntosh",
      position: "Director of Operations",
      bio: "Layne oversees day-to-day operations across all office locations, ensuring every project runs smoothly from start to finish.",
      profilePic: layne,
      contact: "502-529-9552"
    },
    {
      name: "Matt Bradley",
      position: "Sales Manager",
      bio: "Matt leads our sales team with a focus on customer satisfaction and a deep understanding of roofing and solar solutions, helping homeowners find the best options for their needs.",
      profilePic: matt,
      photoPosition: "center center",
      contact: "502-888-6032"
    },
    {
      name: "Richard Wise",
      position: "Team Leader",
      bio: "Richard leads our sales team with a deep commitment to customer satisfaction and extensive knowledge of roofing solutions.",
      profilePic: richard,
      photoPosition: "center center",
      contact: "502-443-3237"
    },
    {
      name: "Tony Judd",
      position: "Project Foreman",
      bio: "Tony oversees all active builds on-site, ensuring every project is completed properly, on time, and to the highest standard of quality.",
      profilePic: tony,
      photoPosition: "center center",
      contact: "812-557-1443"
    },
    {
      name: "Lacy McIntosh",
      position: "Office Manager",
      bio: "Lacy keeps our office running smoothly, supporting the team and ensuring every customer interaction is handled with care and professionalism.",
      profilePic: lacy,
      contact: "812-786-8995"
    },
    {
      name: "John Blumenschein",
      position: "Office Manager",
      bio: "John is a reliable presence in the office, helping coordinate day-to-day tasks and keeping operations organized across all locations.",
      profilePic: john,
      contact: "502-693-2355"
    },
    {
      name: "Seth Thomas",
      position: "Salesman",
      bio: "Seth brings energy and dedication to every customer interaction, helping homeowners find the right roofing and solar solutions for their needs.",
      profilePic: SethThomas,
      contact: "812-786-4989"
    }
  ];

  const cardWidth = 300;
  const cardGap = 20;
  const totalPages = Math.ceil(teamMembers.length / slidesPerView);
  const maxIndex = totalPages - 1;
  const wrapperWidth = slidesPerView * cardWidth + (slidesPerView - 1) * cardGap;
  const trackOffset = currentIndex * slidesPerView * (cardWidth + cardGap);

  const coreValues = [
    {
      title: "Quality",
      description: "We use only premium materials and employ skilled craftsmen to ensure every roof we install or repair meets the highest standards of quality and durability.",
      icon: "fa-medal"
    },
    {
      title: "Integrity",
      description: "Honesty and transparency guide all our business practices. We provide fair pricing, clear communication, and always do what's right for our customers.",
      icon: "fa-handshake"
    },
    {
      title: "Excellence",
      description: "We strive for excellence in every aspect of our work, from the initial consultation to the final inspection, ensuring complete customer satisfaction.",
      icon: "fa-star"
    }
  ];

  return (
    <div className="about-container">
      {/* Hero Section */}
      <div 
        className="top-section" 
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Professional%20roofing%20crew%20working%20on%20a%20modern%20house%20roof%20with%20beautiful%20sunset%20in%20background%2C%20dark%20moody%20atmosphere%20with%20dramatic%20clouds%20and%20golden%20light%2C%20high%20quality%20professional%20photography%20of%20roofing%20work%20in%20progress%2C%20cinematic%20lighting&width=1440&height=800&seq=hero1&orientation=landscape')`
        }}
      >
        <div className="top-overlay"></div>
        <div className="top-content">
          <h1>About Us</h1>
          <p>Building trust through quality craftsmanship and exceptional service since 2005</p>
        </div>
      </div>

      {/* Our Story Section */}
      <section className="our-story">
        <div className="section-header">
          <i className="fas fa-home icon-highlight"></i>
          <h2>Our Story</h2>
          <div className="section-underline"></div>
        </div>
        <div className="story-content">
          <div className="story-text">
            <p>
              Founded in 2009 in Louisville, KY, Affordable Roofing + Solar Solutions is a family-owned business built on dedication, expertise, and a commitment to getting the job done right.
            </p>
            <p>
              In 2023, we rebranded to better reflect our expanded services and commitment to providing both roofing and solar solutions.
            </p>
            <p>
              What started as a local Louisville operation has grown into a multi-state company with offices in Kentucky, Oklahoma, Nebraska, Missouri, and Kansas. No matter where you are, you get the same personal approach and high standards we've built our reputation on.
            </p>
            <p>
              Today, we're proud to have completed over 1,500 projects, each one reflecting our commitment to quality workmanship and customer satisfaction. We combine traditional roofing techniques with modern solar solutions to help homeowners and businesses achieve both protection and energy efficiency.
            </p>
          </div>
          <div className="story-image">
            <img 
              src={grouppic}
              alt="Summit Roofing Team"
            />
          </div>
        </div>
      </section>

      {/* Core Values Section */}
      <section className="core-values">
        <div className="section-header">
          <h2>Core Values</h2>
          <div className="section-underline"></div>
          <p className="section-subtext">
            The principles that guide our work and define our commitment to excellence
          </p>
        </div>
        <div className="core-values-grid">
          {coreValues.map((value, index) => (
            <div key={index} className="core-value">
              <div className="value-icon">
                <i className={`fas ${value.icon}`}></i>
              </div>
              <h3>{value.title}</h3>
              <p>{value.description}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Team Section */}
      <section className="team-section">
        <div className="section-header">
          <h2>Meet Our Team</h2>
          <div className="section-underline"></div>
          <p className="section-subtext">
            The dedicated professionals who make our success possible
          </p>
        </div>
        <div className="team-slider-container">
          <button
            className="slider-btn slider-btn--prev"
            onClick={() => setCurrentIndex(i => Math.max(0, i - 1))}
            disabled={currentIndex === 0}
            aria-label="Previous"
          >
            &#8249;
          </button>

          <div className="team-slider-wrapper" style={{ width: wrapperWidth }}>
            <div
              className="team-slider-track"
              style={{ transform: `translateX(-${trackOffset}px)` }}
            >
              {teamMembers.map((member, index) => (
                <div key={index} className="team-member">
                  <div className="member-image">
                    {member.profilePic ? (
                      <img
                        src={member.profilePic}
                        alt={member.name}
                        style={{ objectPosition: member.photoPosition || 'center top' }}
                      />
                    ) : (
                      <div className="member-initials">
                        {member.name.split(' ').map(n => n[0]).join('')}
                      </div>
                    )}
                  </div>
                  <div className="member-info">
                    <h3>{member.name}</h3>
                    <p className="member-position">{member.position}</p>
                    <p className="member-bio">{member.bio}</p>
                    {member.contact && (
                      <div className="member-contact">
                        <i className="fas fa-phone"></i>
                        <span>{member.contact}</span>
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>

          <button
            className="slider-btn slider-btn--next"
            onClick={() => setCurrentIndex(i => Math.min(maxIndex, i + 1))}
            disabled={currentIndex === maxIndex}
            aria-label="Next"
          >
            &#8250;
          </button>
        </div>
      </section>

      {/* Experience Highlights Section */}
      <section id="stats-section" className="experience-section">
        <div className="section-header">
          <h2>Our Experience</h2>
          <div className="section-underline"></div>
        </div>
        <div className="experience-grid">
          <div className="experience-item">
            <Counter end={20} duration={2000} label="Years in Business" suffix="+" />
          </div>
          <div className="experience-item">
            <Counter end={1500} duration={2000} label="Projects Completed" suffix="+" />
          </div>
          <div className="experience-item">
            <Counter end={98} duration={2000} label="Customer Satisfaction" suffix="%" />
          </div>
        </div>
      </section>

      {/* Contact CTA Section */}
      <section 
        className="cta-section" 
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Modern%20roofing%20installation%20on%20residential%20house%20with%20dramatic%20sky%20in%20background%2C%20dark%20moody%20professional%20photography%20of%20roofing%20work%20with%20dramatic%20clouds%20and%20atmospheric%20lighting%2C%20high%20quality%20construction%20photography&width=1440&height=600&seq=cta1&orientation=landscape')`
        }}
      >
        <div className="cta-overlay"></div>
        <div className="cta-content">
          <h2>Ready to Transform Your Roof?</h2>
          <p>
            Let's discuss how we can enhance your home with our expert roofing and solar solutions. Our team is ready to bring your vision to life.
          </p>
          <a href="/contact-us" className="contact-btn">
            Get Started Today <i className="fas fa-arrow-right"></i>
          </a>
        </div>
      </section>
    </div>
  );
};

export default AboutUs;

